module.exports = __webpack_public_path__ + "static/media/settings-gear-black-icon.5607bb1a.svg";